"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = transformLabel;

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function transformLabel(_ref) {
  var floating = _ref.floating,
      top = _ref.top,
      floatFromFontSize = _ref.floatFromFontSize,
      floatFromLineHeight = _ref.floatFromLineHeight,
      floatToFontSize = _ref.floatToFontSize,
      floatToPaddingLeft = _ref.floatToPaddingLeft,
      floatToPaddingRight = _ref.floatToPaddingRight,
      floatToPaddingTop = _ref.floatToPaddingTop;

  if (floating) {
    if (top) {
      return {
        transform: "scale(".concat((0, _pixelToNumber["default"])(floatFromFontSize) / (0, _pixelToNumber["default"])(floatToFontSize), ") translate3d(0px, 0px, 0px)")
      };
    } else {
      // label floats and increase size relative to lineHeight
      return {
        transform: "translateY(".concat((0, _pixelToNumber["default"])(floatFromLineHeight) + (0, _pixelToNumber["default"])(floatToPaddingTop), "px)\n                scale(1)"),
        paddingLeft: floatToPaddingLeft,
        paddingRight: floatToPaddingRight,
        overflow: 'hidden'
      };
    }
  }
}